export enum DriverIdType {
    None = 0,
    Fob = 1,
    Tacho = 2,
    Mdt = 3
}

export enum TachoType {
    None = 0,
    Siemens = 1,
    Stoneridge = 2
}

export enum IgnitionType {
    Unknown = 0,
    None = 1,
    Ignition = 2,
    EngineRun = 3
}

export enum EngineerJobItemStatus {
    Incomplete = 0,
    Complete = 1,
    Cancelled = 2,
    Failed = 3
}

export enum EngineerJobItemType {
    Install = 0,
    Uninstall = 1,
    Reinstall = 3,
    ServiceCall = 4,
    Upgrade = 5
}

export enum EngineerCommissionStatus {
    Submitted,
    Complete,
    Saved,
    Failed,
    FailedComplete
}

export enum ExtendedDetails {
    None,
    Device,
    SIM
}

export enum CommissionPeripheralForm {
    None,
    Camera
}

export enum CommissionDurationPeriods {
    LessThanThirtyMins,
    LessThanHour,
    LessThanHourHalf,
    LessThenTwoHours,
    LessThanTwoHalf,
    LessThanThree,
    LessThanThreeHalf,
    LessThanFour,
    LessThanFourHalf,
    MoreThanFive
}

export enum NonTestableDevices {
    DVS,
    Transcan
}

export enum IAampAlarmType {
    VideoLoss = 1,
    MotionDetection = 2,
    Cover = 3,
    StorageException = 4,
    IO1 = 5,
    IO2 = 6,
    IO3 = 7,
    IO4 = 8,
    IO5 = 9,
    IO6 = 10,
    IO7 = 11,
    IO8 = 12,
    PanicAlarm = 13,
    LowSpeed = 14,
    HighSpeed = 0xF,
    LowVoltage = 0x10,
    ACC = 17,
    Fence = 18,
    IllegalPowerOff = 19,
    IllegalShutdown = 20,
    TemperatureAlarm = 29,
    DistanceAlarm = 36,
    TemperatureChangeAlarm = 47,
    FatigueDriving = 58,
    NoDriver = 59,
    DriverCall = 60,
    DriverSmoke = 61,
    DriverUnderDistraction = 62,
    LaneDeparture = 0x3F,
    FontCarCollision = 0x40,
    AbnormalBootAlarm = 74,
    CarDistanceTooClose = 162,
    PedestrianCollision = 163,
    DriverYawn = 164,
    LeftBlindZone = 165,
    RightBlindZone = 166
}

export enum ValidationResult {
    Pass,
    Warning,
    Fail
}

export enum InstallSetupCode {
    CalampAndFlexTruck,
    CalampAndFlexVan,
    CalampBasic,
    JPOD,
    OBD,
    GV600TTU,
    GV350,
    GV350WithG2,
    DigiDL,
    Temperature,
    FourGAddsecureCamera,
    AampDvr,
    WhiteListNoDataTests,
    FtCloudCamera,
    Squarell
}

export enum Category {
    General,
    Sim,
    Gps,
    Can,
    RoadviewCamera,
    AampCamera,
    Temperature,
    Tacho,
    FtCloudCamera
}

export enum CommissioningCheckType {
    DeviceInStockCheck,
    DeviceNotAssigned,
    BasicPlotCheck,
    GPSLocationCheck,
    GPSRegularUpdates,
    IgnitionOnOff,
    OdoSet,
    RecentSensorData,
    BasicFuelLevel,
    CANOdo,
    TotalFuelAccumulation,
    FuelUsedIdle,
    IncreaseInIdleTime,
    FMSOnOff,
    Driver,
    PTOFuel,
    TachoModeChange,
    ThresholdsSet,
    FMSSpamming,
    PlotCheck,
    GpsCheck,
    SensorDataCheck,
    FuelDataCheck,
    SimStatusCheck,
    FuelDataPopulated,
    DeviceInStockCheck4G,
    SdCardCheck4G,
    ConfigCheck4G,
    IgnitionCheck4G,
    VideoCheck4G,
    SimStatusCheck4G,
    SimCheckAamp,
    GpsCheckAamp,
    AlarmCheckAamp,
    FootageHistoryCheckAamp,
    TemperatureRecordsCheck,
    TemperatureProbeCountCheck,
    TachoRecordsCreatedCheck,
    ModeChangeCheck,
    FtCloudGpsCheck,
    FtCloudAlarmCheck,
    FtCloudFootageHistoryCheck
}

export enum AampSimStatus {
    None,
    NoSimCard,
    NoModuleAndSimCard,
    ModuleAndSimCardDetected
}

export enum ImportStrategyReference {
    Device,
    Engineer,
    JobItem
}

export enum ImportType {
    Peripheral,
    Unit,
    Engineer,
    JobItem
}

export enum CommissionVisitStatus {
    Active,
    Approved,
    Rejected
}

export enum CommissionActionType {
    Install,
    Uninstall,
    Other
}

export enum CommissionWorkflowType {
    UnitAssociation = 0,
    PeripheralAssociation = 1,
    Squarell = 2,
    Transcan = 3,
    DigiDL = 4,
    P100Config = 5,
    CameraChannel = 6,
}
